/**
 * @generated SignedSource<<149f7edce0cab55724e3a36321ff49e2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutMobileSummaryPane_buyer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useCustomsMessagingQuery_buyer">;
  readonly " $fragmentType": "CheckoutMobileSummaryPane_buyer";
};
export type CheckoutMobileSummaryPane_buyer$key = {
  readonly " $data"?: CheckoutMobileSummaryPane_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutMobileSummaryPane_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutMobileSummaryPane_buyer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useCustomsMessagingQuery_buyer"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "7aa3ed369d8df1ff0067787f0d222823";

export default node;
